let domains = {};

domains = require('../data/domains')

module.exports = domains;